import SceDropDown from './dropDown';
import NotificationHelper from './notificationHelper';
class SetUpVoiceDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Phone: this.props.dropDownData.phoneSet,
      placeholder:!_.isEmpty(this.props.selectedValue) ? this.props.selectedValue : 'Enter Phone',
    };
  }
  componentWillMount() {
    this.getPhoneList(this.props.dropDownData.phoneSet);
  }
  componentWillReceiveProps(nextProps) {
    this.getPhoneList(nextProps.dropDownData.phoneSet);
  }
  getPhoneList(phoneList) {
    let selectedPhone = phoneList.filter((phone) => {
      return phone.value !== 'addPhone' || phone.value !== 'No phone alerts';
    });
    let voiceValueArr = selectedPhone.map((obj)=>obj.telephoneNumber);
    let selectBoxPhoneList = selectedPhone.map(function (phone, index) {
    let telephoneNumber = NotificationHelper.formatPhoneNumWithStar(phone.telephoneNumber);
      return {
        name: telephoneNumber, value: telephoneNumber, encryptedPhoneNumber: phone.encryptedPhoneNumber, type: phone.type, indicatorSmsEnabled: phone.indicatorSmsEnabled, indicatorTelephone: phone.indicatorTelephone
      };
    });
    
    this.setState({ Phone: selectBoxPhoneList }, () => { });
  }
 onAddPhoneConfirmDialogClick = (e,name,value,encVal) => {
    this.props.onModifyCustomerPreference('voice', encVal, value);
    
  }
onSelectDropDown = (e) => {
    var reqObj={...e};
    reqObj.id=this.props.id;
    this.props.onSelectDropDown(reqObj);
  }
render() {
    return (
      <div>
        <SceDropDown 
            id={'phoneNumberSelection_' + this.props.id+this.props.dropdownDiffererentiator}
            selectBoxData={this.state.Phone}
            placeholder={this.state.placeholder}
            handleClick={this.onSelectDropDown}
            errorMessage={this.props.isSameValueError ? 'Primary and Secondary Contact details cannot be same.':''}
            selectErrorMessage={'Please select phone number'}
            isError={this.props.isSameValueError}
            triggerOnClick={this.props.triggerOnClick}
            onDoneEnabledButton={this.props.onDoneEnabledButton}
            onAddPhoneConfirmDialogClick={this.onAddPhoneConfirmDialogClick}
            inputButtonText={this.props.inputButtonText}
            addContactEncValueArr={this.props.addContactEncValueArr}
          />
      </div>
    );
  }
}

export default SetUpVoiceDropdown;
